import React from 'react';
import { Hero } from '../components/Hero';
import { Story } from '../components/Story';
import { Reasons } from '../components/Reasons';
import { Included } from '../components/Included';
import { Audiences } from '../components/Audiences';
import { Objections } from '../components/Objections';
import { Guarantee } from '../components/Guarantee';
import { Closing } from '../components/Closing';
import { Footer } from '../components/Footer';
export function Landing() {
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-107" data-mp="3h3zrxsg9e4h">
      <Hero data-id="element-108" data-mp="3fj6sclsa38q" />
      <main data-id="element-109" data-mp="3ezmip8nv2rj">
        <Story data-id="element-110" data-mp="3erat0o9y3hx" />
        <Reasons data-id="element-111" data-mp="882j768qisby" />
        <Included data-id="element-112" data-mp="87kcffog4vps" />
        <Audiences data-id="element-113" data-mp="893t37e0l8s3" />
        <Objections data-id="element-114" data-mp="88lzkiiql8nv" />
        <Guarantee data-id="element-115" data-mp="8a6n3o6mvrc8" />
        <Closing data-id="element-116" data-mp="c9xi64370tmk" />
      </main>
      <Footer data-id="element-117" data-mp="c84b4noo47e1" />
    </div>;
}